var _mask, _path, _mask2, _path2, _mask3, _path3, _mask4, _path4, _mask5, _rect, _mask6, _rect2, _mask7, _rect3, _mask8, _rect4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _mask9, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 96,
    viewBox: "0 0 93 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_317_1788",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6992 85.02C11.6992 81.5738 14.493 78.78 17.9392 78.78H73.3192C76.7655 78.78 79.5592 81.5738 79.5592 85.02V94.38C79.5592 94.8108 79.21 95.16 78.7792 95.16H12.4792C12.0484 95.16 11.6992 94.8108 11.6992 94.38V85.02Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6992 85.02C11.6992 81.5738 14.493 78.78 17.9392 78.78H73.3192C76.7655 78.78 79.5592 81.5738 79.5592 85.02V94.38C79.5592 94.8108 79.21 95.16 78.7792 95.16H12.4792C12.0484 95.16 11.6992 94.8108 11.6992 94.38V85.02Z",
    stroke: "white",
    strokeWidth: 4.68,
    mask: "url(#path-1-inside-1_317_1788)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_317_1788",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6894 81.1136C65.2874 79.1185 69.443 76.2295 72.9149 72.6146C76.3868 68.9997 79.1058 64.7309 80.9138 60.0562C82.7218 55.3815 83.5828 50.3941 83.4469 45.3837C83.3109 40.3734 82.1806 35.4401 80.1218 30.8703L78.0973 31.7824C80.0353 36.084 81.0992 40.7277 81.2272 45.444C81.3552 50.1602 80.5447 54.8549 78.8428 59.2552C77.1409 63.6555 74.5816 67.6738 71.3134 71.0765C68.0453 74.4792 64.1336 77.1986 59.8055 79.0767L60.6894 81.1136Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6894 81.1136C65.2874 79.1185 69.443 76.2295 72.9149 72.6146C76.3868 68.9997 79.1058 64.7309 80.9138 60.0562C82.7218 55.3815 83.5828 50.3941 83.4469 45.3837C83.3109 40.3734 82.1806 35.4401 80.1218 30.8703L78.0973 31.7824C80.0353 36.084 81.0992 40.7277 81.2272 45.444C81.3552 50.1602 80.5447 54.8549 78.8428 59.2552C77.1409 63.6555 74.5816 67.6738 71.3134 71.0765C68.0453 74.4792 64.1336 77.1986 59.8055 79.0767L60.6894 81.1136Z",
    stroke: "white",
    strokeWidth: 4.68,
    mask: "url(#path-2-inside-2_317_1788)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_317_1788",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9386 11.8155C56.3956 9.8052 51.5011 8.70945 46.5346 8.59075C41.5681 8.47206 36.6269 9.33275 31.993 11.1237C27.3592 12.9146 23.1234 15.6007 19.5277 19.0286C15.9319 22.4565 13.0465 26.5591 11.0363 31.1021C9.02603 35.6451 7.93027 40.5396 7.81158 45.5061C7.69289 50.4726 8.55358 55.4138 10.3445 60.0477C12.1354 64.6816 14.8215 68.9173 18.2495 72.5131C21.6774 76.1088 25.7799 78.9942 30.323 81.0045L31.2215 78.9739C26.9451 77.0816 23.0833 74.3656 19.8566 70.9809C16.6299 67.5962 14.1015 63.6091 12.4157 59.2472C10.7299 54.8853 9.9197 50.2341 10.0314 45.5592C10.1432 40.8842 11.1746 36.277 13.0669 32.0006C14.9591 27.7243 17.6751 23.8625 21.0598 20.6358C24.4445 17.4091 28.4317 14.8807 32.7935 13.1949C37.1554 11.5091 41.8066 10.6989 46.4816 10.8106C51.1565 10.9223 55.7637 11.9538 60.0401 13.846L60.9386 11.8155Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9386 11.8155C56.3956 9.8052 51.5011 8.70945 46.5346 8.59075C41.5681 8.47206 36.6269 9.33275 31.993 11.1237C27.3592 12.9146 23.1234 15.6007 19.5277 19.0286C15.9319 22.4565 13.0465 26.5591 11.0363 31.1021C9.02603 35.6451 7.93027 40.5396 7.81158 45.5061C7.69289 50.4726 8.55358 55.4138 10.3445 60.0477C12.1354 64.6816 14.8215 68.9173 18.2495 72.5131C21.6774 76.1088 25.7799 78.9942 30.323 81.0045L31.2215 78.9739C26.9451 77.0816 23.0833 74.3656 19.8566 70.9809C16.6299 67.5962 14.1015 63.6091 12.4157 59.2472C10.7299 54.8853 9.9197 50.2341 10.0314 45.5592C10.1432 40.8842 11.1746 36.277 13.0669 32.0006C14.9591 27.7243 17.6751 23.8625 21.0598 20.6358C24.4445 17.4091 28.4317 14.8807 32.7935 13.1949C37.1554 11.5091 41.8066 10.6989 46.4816 10.8106C51.1565 10.9223 55.7637 11.9538 60.0401 13.846L60.9386 11.8155Z",
    stroke: "white",
    strokeWidth: 4.68,
    mask: "url(#path-3-inside-3_317_1788)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_317_1788",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6598 24.7695C74.9894 22.3744 73.0473 20.1808 70.8723 18.2324L69.3907 19.8863C71.438 21.7203 73.2662 23.7852 74.8385 26.0398L76.6598 24.7695Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6598 24.7695C74.9894 22.3744 73.0473 20.1808 70.8723 18.2324L69.3907 19.8863C71.438 21.7203 73.2662 23.7852 74.8385 26.0398L76.6598 24.7695Z",
    stroke: "white",
    strokeWidth: 4.68,
    mask: "url(#path-4-inside-4_317_1788)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-5_317_1788",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.6191,
    y: 52.26,
    width: 8.58,
    height: 14.04,
    rx: 1.56
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.6191,
    y: 52.26,
    width: 8.58,
    height: 14.04,
    rx: 1.56,
    stroke: "white",
    strokeWidth: 4.68,
    mask: "url(#path-5-inside-5_317_1788)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-6_317_1788",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.0996,
    y: 47.58,
    width: 8.58,
    height: 18.72,
    rx: 1.56
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0996,
    y: 47.58,
    width: 8.58,
    height: 18.72,
    rx: 1.56,
    stroke: "white",
    strokeWidth: 4.68,
    mask: "url(#path-6-inside-6_317_1788)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-7_317_1788",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.5801,
    y: 42.9,
    width: 8.58,
    height: 23.4,
    rx: 1.56
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5801,
    y: 42.9,
    width: 8.58,
    height: 23.4,
    rx: 1.56,
    stroke: "white",
    strokeWidth: 4.68,
    mask: "url(#path-7-inside-7_317_1788)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-8_317_1788",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.0605,
    y: 37.4401,
    width: 8.58,
    height: 28.86,
    rx: 1.56
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0605,
    y: 37.4401,
    width: 8.58,
    height: 28.86,
    rx: 1.56,
    stroke: "white",
    strokeWidth: 4.68,
    mask: "url(#path-8-inside-8_317_1788)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5801 26.5201L59.2801 23.4001",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 35.1001L59.28 23.4001",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 35.1001L55.38 32.7601",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6992 28.86L47.5792 26.52",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2598 88.53H54.5998",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0605 65.1301H70.9821",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0605 88.53L63.1805 88.53",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1548 4.35983C65.2804 4.02029 65.7607 4.02029 65.8863 4.35983L66.9836 3.9538L65.8863 4.35983L68.2824 10.8352C68.5589 11.5824 69.1481 12.1716 69.8953 12.4481L76.3707 14.8442C76.7102 14.9699 76.7102 15.4501 76.3707 15.5757L69.8953 17.9718C69.1481 18.2483 68.5589 18.8375 68.2824 19.5848L65.8863 26.0601C65.7607 26.3997 65.2804 26.3997 65.1548 26.0601L62.7587 19.5848C62.4822 18.8375 61.893 18.2483 61.1458 17.9718L54.6704 15.5757C54.3309 15.4501 54.3309 14.9699 54.6704 14.8442L61.1458 12.4481C61.893 12.1716 62.4822 11.5824 62.7587 10.8352L65.1548 4.35983Z",
    stroke: "white",
    strokeWidth: 2.34
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.245 21.5199C77.3707 21.1804 77.8509 21.1804 77.9765 21.5199L79.3193 25.1486C79.5958 25.8959 80.185 26.485 80.9322 26.7615L84.5609 28.1043C84.9005 28.2299 84.9005 28.7102 84.5609 28.8358L80.9322 30.1785C80.185 30.455 79.5958 31.0442 79.3193 31.7915L77.9765 35.4202C77.8509 35.7597 77.3707 35.7597 77.245 35.4202L75.9023 31.7915C75.6258 31.0442 75.0366 30.455 74.2894 30.1785L70.6606 28.8358C70.3211 28.7102 70.3211 28.2299 70.6606 28.1043L74.2894 26.7615C75.0366 26.485 75.6258 25.8959 75.9023 25.1486L77.245 21.5199Z",
    stroke: "white",
    strokeWidth: 2.34
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9296 16.7701C24.5696 21.4501 19.1096 26.9101 15.5996 35.4901M40.9496 14.8201C40.1696 14.8201 38.6096 15.2101 38.6096 15.2101M19.1096 43.6801C34.7096 43.9921 46.6696 34.1901 50.6996 29.2501M19.4996 43.6858C38.2196 48.7501 51.3496 37.7001 55.3796 32.7601",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-9_317_1788",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9386 11.8155C56.3956 9.8052 51.5011 8.70945 46.5346 8.59075C41.5681 8.47206 36.6269 9.33275 31.993 11.1237C27.3592 12.9146 23.1234 15.6007 19.5277 19.0286C15.9319 22.4565 13.0465 26.5591 11.0363 31.1021C9.02603 35.6451 7.93027 40.5396 7.81158 45.5061C7.69289 50.4726 8.55358 55.4138 10.3445 60.0477C12.1354 64.6816 14.8215 68.9173 18.2495 72.5131C21.6774 76.1088 25.7799 78.9942 30.323 81.0045L31.2215 78.9739C26.9451 77.0816 23.0833 74.3656 19.8566 70.9809C16.6299 67.5962 14.1015 63.6091 12.4157 59.2472C10.7299 54.8853 9.9197 50.2341 10.0314 45.5592C10.1432 40.8842 11.1746 36.277 13.0669 32.0006C14.9591 27.7243 17.6751 23.8625 21.0598 20.6358C24.4445 17.4091 28.4317 14.8807 32.7935 13.1949C37.1554 11.5091 41.8066 10.6989 46.4816 10.8106C51.1565 10.9223 55.7637 11.9538 60.0401 13.846L60.9386 11.8155Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9386 11.8155C56.3956 9.8052 51.5011 8.70945 46.5346 8.59075C41.5681 8.47206 36.6269 9.33275 31.993 11.1237C27.3592 12.9146 23.1234 15.6007 19.5277 19.0286C15.9319 22.4565 13.0465 26.5591 11.0363 31.1021C9.02603 35.6451 7.93027 40.5396 7.81158 45.5061C7.69289 50.4726 8.55358 55.4138 10.3445 60.0477C12.1354 64.6816 14.8215 68.9173 18.2495 72.5131C21.6774 76.1088 25.7799 78.9942 30.323 81.0045L31.2215 78.9739C26.9451 77.0816 23.0833 74.3656 19.8566 70.9809C16.6299 67.5962 14.1015 63.6091 12.4157 59.2472C10.7299 54.8853 9.9197 50.2341 10.0314 45.5592C10.1432 40.8842 11.1746 36.277 13.0669 32.0006C14.9591 27.7243 17.6751 23.8625 21.0598 20.6358C24.4445 17.4091 28.4317 14.8807 32.7935 13.1949C37.1554 11.5091 41.8066 10.6989 46.4816 10.8106C51.1565 10.9223 55.7637 11.9538 60.0401 13.846L60.9386 11.8155Z",
    stroke: "white",
    strokeWidth: 4.68,
    mask: "url(#path-19-inside-9_317_1788)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.d40728734363e721c08e83b56ae837e2.svg";
export { ForwardRef as ReactComponent };